import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

//Visitor
import VisitorHome from "./views/Visitor_Home";
import VisitorInterests from "./views/Visitor_Step10_Interests";
import VisitorContactDetails from "./views/Visitor_Step20_ContactDetails";
import VisitorAddress from "./views/Visitor_Step30_Address";
import VisitorCheckout from "./views/Visitor_Step40_Checkout";

//Sponsor Speaker
import SponsorSpeakerHome from "./views/SponsorSpeaker_Home";
import SponsorSpeakerTickets from "./views/SponsorSpeaker_Step10_Tickets";
import SponsorSpeakerAddress from "./views/SponsorSpeaker_Step20_Address";
import SponsorSpeakerTicketAddress from "./views/SponsorSpeaker_Step30_TicketAddress";

//Confirmation
import Confirmation from "./views/Step_Confirmation";

//Not found
import PageNotFound from "./views/components/PageNotFound";

import "./css/style.css";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<PageNotFound />} />
                <Route path="/" element={<PageNotFound />} />

                <Route path="/:language/visitor/home" element={<VisitorHome />} />
                <Route path="/:language/visitor/interests" element={<VisitorInterests />} />
                <Route path="/:language/visitor/contact-details" element={<VisitorContactDetails />} />
                <Route path="/:language/visitor/address" element={<VisitorAddress />} />
                <Route path="/:language/visitor/checkout" element={<VisitorCheckout />} />

                <Route path="/:language/sponsor-speaker/home" element={<SponsorSpeakerHome />} />
                <Route path="/:language/sponsor-speaker/tickets" element={<SponsorSpeakerTickets />} />
                <Route path="/:language/sponsor-speaker/address" element={<SponsorSpeakerAddress />} />
                <Route path="/:language/sponsor-speaker/ticket-address" element={<SponsorSpeakerTicketAddress />} />

                <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
                <Route path="/:language/confirmation" element={<Confirmation />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
